import { ANTRAGS_OVERVIEW_UI_MAP } from './antrags-overview-ui-map.token';
import { AntragSupportingData } from '../interfaces';
import { AntragUiData } from './antrag-ui-data.interface';
import { Inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { ResourceProvider } from '../providers/resource/resource';
import { TokenState } from '../models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AntragSupportingDataService {
  private readonly _statesThatIndicateDifferentToken = new Set([TokenState.Outdated, TokenState.Na]);
  private cache$: Observable<AntragSupportingData> | undefined;

  constructor(
    private readonly resourceProvider: ResourceProvider,
    @Inject(ANTRAGS_OVERVIEW_UI_MAP) private antragsOverviewUiMap: Map<number, AntragUiData>,
  ) {}

  public get completeStates(): Observable<number[]> {
    return this.supportingData.pipe(map((s) => s.completeStates));
  }

  public get incompleteStates(): Observable<number[]> {
    return this.supportingData.pipe(map((s) => s.incompleteStates));
  }

  public get supportingData(): Observable<AntragSupportingData> {
    if (!this.cache$) {
      this.cache$ = this.requestSupportingData().pipe(shareReplay(1));
    }

    return this.cache$;
  }

  private get states(): Observable<{ [p: number]: string }> {
    return this.supportingData.pipe(map((x) => x.states));
  }

  public getStateTextRepresentation(state: number): Observable<string> {
    return this.states.pipe(map((s: AntragSupportingData['states']) => s[state]));
  }

  public getCssAndIconForState(state: number): AntragUiData {
    return <AntragUiData>this.antragsOverviewUiMap.get(state);
  }

  public canAntragBeDeleted(state: number): Observable<boolean> {
    return this.supportingData.pipe(map((x) => x.incompleteStates.includes(state)));
  }

  public hasEncryptionIssue(tokenState: TokenState): Observable<boolean> {
    return this.supportingData.pipe(map((x) => x.statesForAntragEncryptionHasIssues.has(tokenState)));
  }

  private requestSupportingData(): Observable<AntragSupportingData> {
    return this.resourceProvider.getAntragStates().pipe(
      map(
        (o) =>
          ({
            ...o,
            statesForAntragEncryptionHasIssues: this._statesThatIndicateDifferentToken,
          }) as AntragSupportingData,
      ),
    );
  }
}
